export class UpdateProfileViewModel {
  Id: string;
  Email: string;
  FirstName: string;
  LastName: string;
  Language: string;
}
